<!--  -->
<template>
  <router-view />
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { defineComponent} from "vue";

export default defineComponent({});
</script>
<style lang='less' scoped>
</style>